import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGE_CODES } from './languages';

/** First URL segment when it is a supported language code (e.g. /tr/... -> tr). */
export function getLangFromPathname(pathname = '') {
    const segment = (pathname || '').split('/').filter(Boolean)[0];
    if (segment && SUPPORTED_LANGUAGE_CODES.includes(segment)) {
        return segment;
    }
    return DEFAULT_LANGUAGE;
}

/** Remove /en, /zh, /tr, etc. prefix from a pathname. */
export function stripLangPrefix(pathname = '') {
    const path = pathname || '/';
    const lang = getLangFromPathname(path);
    if (path === `/${lang}`) return '/';
    if (path.startsWith(`/${lang}/`)) {
        const rest = path.slice(lang.length + 1);
        return rest || '/';
    }
    return path;
}

/** Prefix an internal path with the active language segment. */
export function withLangPrefix(lang, path = '/') {
    const code = SUPPORTED_LANGUAGE_CODES.includes(lang) ? lang : DEFAULT_LANGUAGE;
    if (!path || typeof path !== 'string' || path.charAt(0) !== '/') return path;
    return path === '/' ? `/${code}` : `/${code}${path}`;
}
